import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { tenantApi } from '../../api/tenantApi';
import { Panel, Loader, EmptyState, useToast, errText, TenantSelect } from '../ui';

export default function ExceptionLogs() {
  const toast = useToast();
  const [params] = useSearchParams();
  const [clientCode, setClientCode] = useState(params.get('clientCode') || '');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize] = useState(20);
  const [res, setRes] = useState(null);

  const load = async (cc, from, to, p) => {
    if (!cc) return;
    setRes(null);
    try {
      const data = await tenantApi.getExceptionLogs(cc, from, to, p, pageSize);
      setRes(data);
    } catch (err) {
      toast.error(errText(err));
      setRes({ data: [] });
    }
  };

  useEffect(() => {
    if (clientCode) load(clientCode, fromDate, toDate, page);
  }, [page]); // eslint-disable-line

  useEffect(() => {
    if (params.get('clientCode')) load(params.get('clientCode'), '', '', 1);
  }, []); // eslint-disable-line

  const handleSearch = () => { setPage(1); load(clientCode, fromDate, toDate, 1); };

  const rows = res?.data || [];

  return (
    <>
      <h1 className="page-title">exception_log</h1>
      <p className="page-sub">GET /v1/admin/tenants/logs/exceptions — error/exception trail, with date-range filter</p>

      <Panel title="// QUERY">
        <div className="toolbar">
          <div className="toolbar__group">
            <TenantSelect value={clientCode} onSelect={(cc) => setClientCode(cc)} />
            <input type="date" className="term-input" style={{ width: 160 }} value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
            <input type="date" className="term-input" style={{ width: 160 }} value={toDate} onChange={(e) => setToDate(e.target.value)} />
            <button className="term-btn term-btn--solid term-btn--sm" onClick={handleSearch}>run_query</button>
          </div>
        </div>

        {res?.processed !== undefined && (
          <p style={{ fontSize: 11.5, color: 'var(--text-dim)', marginBottom: 12 }}>
            processed: <b style={{ color: 'var(--text)' }}>{res.processed}</b> · errors:{' '}
            <b style={{ color: res.errors ? 'var(--red)' : 'var(--green)' }}>{res.errors}</b>
          </p>
        )}

        {!clientCode && <EmptyState>Enter a clientCode to fetch exception logs.</EmptyState>}
        {clientCode && res === null && <Loader label="fetching exception logs" />}
        {clientCode && res !== null && rows.length === 0 && <EmptyState>No exceptions found for {clientCode} in this range.</EmptyState>}

        {res !== null && rows.length > 0 && (
          <>
            <table className="term-table">
              <thead>
                <tr>{Object.keys(rows[0]).map((k) => <th key={k}>{k}</th>)}</tr>
              </thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={i}>{Object.values(r).map((v, j) => <td key={j}>{String(v)}</td>)}</tr>
                ))}
              </tbody>
            </table>
            <div className="pager">
              <button className="term-btn term-btn--sm" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>← prev</button>
              <span>page {res.page} / {res.totalPages} · {res.totalRecords} records</span>
              <button className="term-btn term-btn--sm" disabled={page >= (res.totalPages || 1)} onClick={() => setPage((p) => p + 1)}>next →</button>
            </div>
          </>
        )}
      </Panel>
    </>
  );
}